import { LEGAL_PRIVACY_BLOCKS_VALUES } from "../constants/legalAndPrivacy";

const stateNames = new Map([
  ["IL", "Illinois"],
  ["MT", "Montana"],
  ["NM", "New Mexico"],
  ["OK", "Oklahoma"],
  ["TX", "Texas"],
]);

const findStateName = (stateCode: string) => {
  return stateNames.get(stateCode);
};

export function getBrowser() {
  const userAgent = navigator.userAgent;
  let tem,
    M = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
    return { name: "IE", version: tem[1] || "" };
  }
  if (M[1] === "Chrome") {
    tem = userAgent.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: "Opera", version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
  if ((tem = userAgent.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
  };
}
/**
 *
 * @param html{string}
 * @param location{object}
 */
const changeHrefAttributeFromString = (html: string, locationObject: { search: string; pathname: string }) => {
  const parser = new DOMParser();
  const document = parser.parseFromString(html, "text/html");
  const anchorLinks = document.querySelectorAll("a");
  const search = new URLSearchParams(location.search);
  const buildSearchRouteForName = (r: string | null) => {
    if (r) {
      search.set("name", r);
    }
    return search.toString();
  };

  Array.from(anchorLinks).forEach(el => {
    const existedAttributeValue: string | null = el.getAttribute("href");
    if (existedAttributeValue?.startsWith("#") && !existedAttributeValue.startsWith("tel")) {
      el.setAttribute("href", `${locationObject.pathname}?${search}${existedAttributeValue}`);
    }

    if (existedAttributeValue && LEGAL_PRIVACY_BLOCKS_VALUES.includes(existedAttributeValue)) {
      el.setAttribute("href", `${locationObject.pathname}?${buildSearchRouteForName(existedAttributeValue)}`);
    }
  });

  return document;
};

export const getStateName = (code: string | undefined) => {
  switch (code) {
    case "il":
      return "illinois";
    case "ok":
      return "oklahoma";
    case "tx":
      return "texas";
    case "mt":
      return "montana";
    case "nm":
      return "new-mexico";
    default:
      return null;
  }
};

const formatData = (str: string) => {
  return str
    .replace(/<(.|\n)*?>/g, "")
    .replace(/&nbsp;/g, " ")
    .replace(/&quot;/g, " ")
    .split("\n")
    .filter(v => v !== " " && v !== "" && v !== "    ")
    .map(el => el.trim());
};

export const uuid = () => {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxx".replace(/[xy]/g, c => {
    const r = (Math.random() * 16) | 0,
      v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};

export const getUrlParam = (query: string) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(query);
};

export const capitalizeFirstLetter = (str: string) => str?.charAt(0).toUpperCase() + str?.slice(1);

export default {
  formatData,
  uuid,
  findStateName,
  getUrlParam,
  getStateName,
  capitalizeFirstLetter,
  getBrowser,
  changeHrefAttributeFromString,
};
